import { pxToRem } from 'utils/styled'
import styled from '@emotion/styled'
import { Text } from 'components/Typography'
import { MemoryShareItems } from 'components/share/MemoryShareItems'

export const SShareModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const STitle = styled(Text)`
  margin-bottom: ${pxToRem(24)}rem;
  color: black;
  font-weight: bold;
  font-size: ${pxToRem(21)}rem;
  text-align: center;
`
export const SShareItems = styled(MemoryShareItems)`
  width: 100%;
`

export const SPreviewContainer = styled.div`
  display: flex;
  width: ${pxToRem(200)}rem;
  height: ${pxToRem(200)}rem;
  box-shadow: var(--card-shadow);
  margin-bottom: ${pxToRem(24)}rem;
  & img,
  video,
  > div {
    width: 100%;
    object-fit: cover;
  }
`
